/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CivAction } from '../model/civAction';
import { CivUuidAction } from '../model/civUuidAction';
import { CivUuidIntAction } from '../model/civUuidIntAction';
import { GameEngineDto } from '../model/gameEngineDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EngineResearchService {

    protected basePath = 'http://localhost:8080/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Choose technology
     * Choose civilization technology for learning
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public chooseTechnologyForLearn(body: CivUuidIntAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public chooseTechnologyForLearn(body: CivUuidIntAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public chooseTechnologyForLearn(body: CivUuidIntAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public chooseTechnologyForLearn(body: CivUuidIntAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling chooseTechnologyForLearn.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling chooseTechnologyForLearn.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/research/choose-tech-to-learn`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Learn choosed
     * Learn all choosed by civilizations technologies
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learnChoosedTechnology(gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public learnChoosedTechnology(gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public learnChoosedTechnology(gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public learnChoosedTechnology(gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling learnChoosedTechnology.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/research/learn-choosed-tech`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Learn technology
     * Learn civilization technology
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public learnTechnology(body: CivUuidIntAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public learnTechnology(body: CivUuidIntAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public learnTechnology(body: CivUuidIntAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public learnTechnology(body: CivUuidIntAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling learnTechnology.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling learnTechnology.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/research/learn-tech`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unchoose technology
     * Unchoose civilization technologies for learning
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unchooseTechnologyForLearn(body: CivAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public unchooseTechnologyForLearn(body: CivAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public unchooseTechnologyForLearn(body: CivAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public unchooseTechnologyForLearn(body: CivAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling unchooseTechnologyForLearn.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling unchooseTechnologyForLearn.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/research/unchoose-tech-to-learn`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Unlearn technology
     * Unlearn civilization technology and remove it from pyramimd
     * @param body 
     * @param gameId Game ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unlearnTechnology(body: CivUuidAction, gameId: number, observe?: 'body', reportProgress?: boolean): Observable<GameEngineDto>;
    public unlearnTechnology(body: CivUuidAction, gameId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GameEngineDto>>;
    public unlearnTechnology(body: CivUuidAction, gameId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GameEngineDto>>;
    public unlearnTechnology(body: CivUuidAction, gameId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling unlearnTechnology.');
        }

        if (gameId === null || gameId === undefined) {
            throw new Error('Required parameter gameId was null or undefined when calling unlearnTechnology.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<GameEngineDto>('post',`${this.basePath}/api/engine/${encodeURIComponent(String(gameId))}/actions/research/unlearn-tech`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
